import React from 'react';
import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { styles } from '../WorkingHours.styles';
import { UserSystemGroupStrings } from 'store/storeTypes';
import { KonnectAnalytics } from 'KonnectAnalytics/konnectAnalytics';

type MixedScheduleBannerProps = {
  isMixed: boolean;
  selectedSystemGroupTypes: UserSystemGroupStrings[];
  viewingSystemGroupType: UserSystemGroupStrings;
  onChangeViewing: (group: UserSystemGroupStrings) => void;
};

const MixedScheduleBanner = ({
  isMixed,
  selectedSystemGroupTypes,
  viewingSystemGroupType,
  onChangeViewing,
}: MixedScheduleBannerProps) => {
  if (!isMixed) return null;

  return (
    <Box sx={styles.mixedBanner}>
      <Box component="span" sx={styles.mixedBannerIcon}>
        ⚠️
      </Box>
      <Box component="span">
        <b>Selected types have different hours.</b> Saving will unify them to the schedule shown
        below.
      </Box>
      <Box sx={styles.mixedBannerViewAs}>
        Viewing
        <Select
          size="small"
          value={viewingSystemGroupType || selectedSystemGroupTypes[0] || ''}
          onChange={e => {
            const group = e.target.value as UserSystemGroupStrings;
            onChangeViewing(group);
            KonnectAnalytics.productionHoursChangeViewingSystemType({ systemGroup: group });
          }}
          sx={styles.mixedBannerSelect}>
          {selectedSystemGroupTypes.map(group => (
            <MenuItem key={group} value={group}>
              {group}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Box>
  );
};

export default MixedScheduleBanner;
